// extracted by mini-css-extract-plugin
module.exports = {"rightAlign":"Alignment_rightAlign__50RIj","leftAlign":"Alignment_leftAlign__2l4Aa","centerAlign":"Alignment_centerAlign__3Sudw"};